import { styled } from '@mui/material'
import { IconCaretDownOutline18 } from 'nucleo-ui-outline-18/components/IconCaretDownOutline18'
import { IconCaretUpOutline18 } from 'nucleo-ui-outline-18/components/IconCaretUpOutline18'
import type { ComponentProps, JSXElementConstructor } from 'react'

// Nucleo's caret icons render as an unfilled outline stroke, but the design sheet's carets are
// solid — override the inner path's fill/stroke rather than leaving the mismatch, since a caret
// drawn as a thin outline reads poorly at the small sizes carets are used at.
const filledCaretSx = { '& path': { fill: 'currentColor', stroke: 'none' } }

type FilledCaret = JSXElementConstructor<ComponentProps<'svg'> & { size?: string | number }>

export const CaretDownOMIcon: FilledCaret = styled(IconCaretDownOutline18)(filledCaretSx)
export const CaretUpOMIcon: FilledCaret = styled(IconCaretUpOutline18)(filledCaretSx)
